import type { Announcement } from '../../types/announcements';

const STATUS_PILLS: Record<string, { label: string; className: string }> = {
  active: { label: 'Aktiv', className: 'bg-green-100 text-green-800' },
  upcoming: { label: 'Kommande', className: 'bg-blue-100 text-blue-800' },
  ended: { label: 'Avslutad', className: 'bg-gray-100 text-gray-600' },
  disabled: { label: 'Avstängd', className: 'bg-red-100 text-red-700' },
};

function getStatus(a: Announcement): string {
  if (!a.enabled) return 'disabled';
  const now = Date.now();
  const start = new Date(a.startsAt).getTime();
  const end = a.endsAt ? new Date(a.endsAt).getTime() : null;
  if (start > now) return 'upcoming';
  if (end && end <= now) return 'ended';
  return 'active';
}

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('sv-SE', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export const AnnouncementList = ({
  announcements,
  onSelect,
}: {
  announcements: Announcement[];
  onSelect: (a: Announcement) => void;
}) => {
  return (
    <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
      <table className="w-full text-left text-sm">
        <thead className="border-b bg-gray-50 text-xs font-medium uppercase text-gray-500">
          <tr>
            <th className="px-4 py-3">Titel</th>
            <th className="px-4 py-3">Status</th>
            <th className="px-4 py-3">Marknader</th>
            <th className="px-4 py-3">Period</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {announcements.map((a) => {
            const status = getStatus(a);
            const pill = STATUS_PILLS[status] ?? STATUS_PILLS.ended;
            return (
              <tr
                key={a.id}
                className="cursor-pointer transition hover:bg-gray-50"
                onClick={() => onSelect(a)}
              >
                <td className="px-4 py-3 font-medium text-gray-900">{a.title}</td>
                <td className="px-4 py-3">
                  <span
                    className={`inline-block rounded-full px-2 py-0.5 text-xs font-medium ${pill.className}`}
                  >
                    {pill.label}
                  </span>
                </td>
                <td className="px-4 py-3 text-gray-600">
                  {a.markets.length === 0 ? 'Alla' : a.markets.join(', ')}
                </td>
                <td className="px-4 py-3 text-gray-600">
                  {formatDate(a.startsAt)}
                  {' — '}
                  {a.endsAt ? formatDate(a.endsAt) : 'Tills vidare'}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
